import { render, staticRenderFns } from "./LockedScreen.vue?vue&type=template&id=2c29a49e&scoped=true&"
import script from "./LockedScreen.vue?vue&type=script&lang=js&"
export * from "./LockedScreen.vue?vue&type=script&lang=js&"
import style0 from "./LockedScreen.vue?vue&type=style&index=0&id=2c29a49e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c29a49e",
  null
  
)

export default component.exports